import { Flex, styled } from '@driftt/dds'

export const StyledContent = styled(Flex, {
  backgroundColor: '$gray2',
  padding: '$2',

  variants: {
    overflow: {
      true: {
        overflow: 'auto',
      },
    },
  },
})

export const StyledHeaderContainer = styled(Flex, {
  minHeight: '80px',
  padding: '0 $4',
  flexShrink: 1,
})
